import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
  Snackbar,
  Alert
} from '@mui/material';
import ParticlesComponent from './Particles';
import { Link, useNavigate } from "react-router-dom";
import axios from '../../services/axios';

const Register = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
  });

  const [error, setError] = useState('');
  const [openSuccess, setOpenSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await axios.post('/register', formData);

      setOpenSuccess(true);

      // Redirigir después de mostrar la notificación
      setTimeout(() => {
        navigate('/login');
      }, 2500);

    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message || 'Error al registrar');
      }
    }
  };

  return (
    <Box sx={styles.container}>

      {/* Imagen izquierda */}
      <Box sx={styles.imageContainer}></Box>

      {/* Partículas */}
      <ParticlesComponent id="tsparticles" style={styles.particles} />

      {/* Formulario */}
      <Box sx={styles.formContainer}>
        <Box sx={styles.form}>

          <Typography variant="h4" sx={styles.title}>
            Crear Cuenta
          </Typography>

          <TextField
            label="Nombre"
            name="name"
            fullWidth
            margin="normal"
            value={formData.name}
            onChange={handleChange}
          />

          <TextField
            label="Correo Electrónico"
            name="email"
            fullWidth
            margin="normal"
            value={formData.email}
            onChange={handleChange}
          />

          <TextField
            label="Contraseña"
            type="password"
            name="password"
            fullWidth
            margin="normal"
            value={formData.password}
            onChange={handleChange}
          />

          <TextField
            label="Confirmar Contraseña"
            type="password"
            name="password_confirmation"
            fullWidth
            margin="normal"
            value={formData.password_confirmation}
            onChange={handleChange}
          />

          {error && (
            <Typography color="error" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}

          <Button
            variant="contained"
            fullWidth
            sx={{ ...styles.button, backgroundColor: '#1976d2' }}
            onClick={handleSubmit}
          >
            Registrarse
          </Button>

          <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>
            ¿Ya tienes cuenta? <Link to="/login">Inicia sesión aquí</Link>
          </Typography>

        </Box>
      </Box>

      {/* ✅ Notificación estilizada */}
      <Snackbar
        open={openSuccess}
        autoHideDuration={2500}
        onClose={() => setOpenSuccess(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success" variant="filled">
          Cuenta creada. Revisa tu correo y verifica tu email antes de iniciar sesión.
        </Alert>
      </Snackbar>

    </Box>
  );
};

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
  },
  imageContainer: {
    flex: 0.5,
    backgroundImage: 'url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbJYJun3zdQESqfgIUZQZEsBnpI5AChIfOKQ&s)',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    zIndex: 1200,
  },
  formContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  form: {
    width: '100%',
    maxWidth: '400px',
    padding: '2rem',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    zIndex: 1,
  },
  title: {
    marginBottom: '2rem',
    color: '#333',
    textAlign: 'center',
  },
  button: {
    marginBottom: '1rem',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 'bold',
  },
  particles: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 0,
  },
};

export default Register;
